import WebBlue from 'assets/icons/home-web_blue.svg'
import WebGray from 'assets/icons/home-web_gray.svg'
import TabletBlue from 'assets/icons/home-tablet_blue.svg'
import TabletGray from 'assets/icons/home-tablet_gray.svg'
import MobileBlue from 'assets/icons/home-mobile_blue.svg'
import MobileGray from 'assets/icons/home-mobile_gray.svg'

export const deviceList = [
  {
    device: 'WEB',
    selectedImg: WebBlue,
    notSelectedImg: WebGray,
  },
  {
    device: 'TABLET',
    selectedImg: TabletBlue,
    notSelectedImg: TabletGray,
  },
  {
    device: 'MOBILE',
    selectedImg: MobileBlue,
    notSelectedImg: MobileGray,
  },
]

export const serviceList = [
  {
    service: '기획',
    title: `홈페이지 제작에 최적화하여
자료를 재가공합니다`,
    description: `플로우 차트, 사이트 맵, 기획서 등
고객 사업의 내용을 홈페이지 제작에 맞게 재가공합니다
아이디어만 있어도 홈페이지 개발이 가능합니다`,
    link: '/skills?key=planning',
    img: require('assets/images/home-image_planning.png'),
    img2: require('assets/images/home-image_planning2.png'),
  },
  {
    service: '디자인',
    title: `남다르지만
사업에 최적화된 디자인`,
    description: `고객이 찾던 디자인, 고객이 생각한 디자인을 넘어
고객에게 필요한 디자인을 제공합니다`,
    link: '/skills?key=design',
    img: require('assets/images/home-image_design.png'),
    img2: require('assets/images/home-image_design2.png'),
  },
  {
    service: '프론트엔드',
    title: `어떤 기기로 확인해도
완벽한 레이아웃`,
    description: `반응형은 기본! 자연스러운 모션까지
템플릿에서 만나볼 수 없는 디테일을 만나보세요`,
    link: '/skills?key=web',
    img: require('assets/images/home-image_frontend.png'),
    img2: require('assets/images/home-image_frontend2.png'),
  },
  {
    service: '백엔드',
    title: `완벽한 커스텀
간편한 관리`,
    description: `특별한 기능을 추가하고 원하는 내용도 관리해보세요
시그마테크놀로지 솔루션은 커스텀이 가능합니다`,
    link: '/skills?key=server',
    img: require('assets/images/home-image_backend.png'),
    img2: require('assets/images/home-image_backend2.png'),
  },
]

export const serviceList2 = [
  {
    service: '기획',
    description1: '홈페이지 문구 변경 후',
    description2: '유효 클릭수 증가',
  },
  {
    service: '디자인',
    description1: '홈페이지 디자인 변경 후',
    description2: '상승하는 이용자 수',
  },
  {
    service: '프론트엔드',
    description1: '홈페이지 리뉴얼 후',
    description2: '어느 화면에서도 최적화되는 화면',
  },
  {
    service: '백엔드',
    description1: '서버 유지보수 후',
    description2: '확연히 달라지는 안정성',
  },
]

export const historyList = [
  {
    year: '2024',
    content: [
      {
        month: '01월',
        text: '2024. 01. 30. 창업기업 확인서',
      },
      {
        month: '01월',
        text: '2024. 01. 30. 창업기업 확인서',
      },
      {
        month: '02월',
        text: '2024. 01. 30. 창업기업 확인서',
      },
    ],
  },
  {
    year: '2023',
    content: [
      {
        month: '01월',
        text: '2024. 01. 30. 창업기업 확인서',
      },
      {
        month: '01월',
        text: '2024. 01. 30. 창업기업 확인서',
      },
      {
        month: '02월',
        text: '2024. 01. 30. 창업기업 확인서',
      },
    ],
  },
  {
    year: '2022',
    content: [
      {
        month: '01월',
        text: '2024. 01. 30. 창업기업 확인서',
      },
      {
        month: '01월',
        text: '2024. 01. 30. 창업기업 확인서',
      },
      {
        month: '02월',
        text: '2024. 01. 30. 창업기업 확인서',
      },
    ],
  },
  {
    year: '2021',
    content: [
      {
        month: '01월',
        text: '2024. 01. 30. 창업기업 확인서',
      },
      {
        month: '01월',
        text: '2024. 01. 30. 창업기업 확인서',
      },
      {
        month: '02월',
        text: '2024. 01. 30. 창업기업 확인서',
      },
    ],
  },
]

export const questionList = [
  {
    idx: 1,
    name: 'service',
    type: 'radio',
    title: '어떤 홈페이지가 필요하신가요?',
    subTitle: '필요한 홈페이지 유형을 선택해주세요',
    answer: [
      { content: '반응형 웹' },
      { content: '웹' },
      { content: '쇼핑몰' },
      { content: '플랫폼' },
      { content: '랜딩페이지' },
      { content: '기타' },
    ],
  },
  {
    idx: 2,
    name: 'prevService',
    type: 'radio',
    title: '기존 홈페이지가 있으신가요?',
    subTitle: '새롭게 제작할 수도, 리뉴얼을 할 수도 있습니다',
    answer: [{ content: '신규 홈페이지 제작' }, { content: '홈페이지 리뉴얼' }],
  },
  {
    idx: 3,
    name: 'payment',
    type: 'radio',
    title: '결제 기능이 필요하신가요?',
    subTitle: '',
    answer: [{ content: '네' }, { content: '아니요' }],
    additionalQuestion: [
      {
        idx: 1,
        name: 'generalPayment',
        type: 'checkbox',
        title: '필요하신 일반결제를 체크해주세요',
        subTitle: `다양한 일반결제 서비스가 필요하실 경우,
pg사 선택에 제한적이거나 수수료가 추가로 발생할 수 있습니다`,
        answer: [
          { content: '신용카드' },
          { content: '계좌이체' },
          { content: '가상계좌' },
          { content: '휴대폰' },
          { content: '기타' },
        ],
      },
      {
        idx: 2,
        name: 'easyPayment',
        type: 'checkbox',
        title: '필요하신 간편결제를 체크해주세요',
        subTitle: `다양한 간편결제 서비스가 필요하실 경우,
수수료가 추가로 발생할 수 있습니다`,
        answer: [
          { content: '네이버페이' },
          { content: '카카오페이' },
          { content: '페이코' },
          { content: '토스' },
          { content: '기타' },
        ],
      },
      {
        idx: 3,
        name: 'pointPayment',
        type: 'radio',
        title: '마일리지나 포인트를 이용하시나요?',
        subTitle: '',
        answer: [{ content: '네' }, { content: '아니요' }],
      },
    ],
  },
  {
    idx: 4,
    name: 'register',
    type: 'radio',
    title: '회원가입이 필요하신가요?',
    subTitle: '',
    answer: [{ content: '네' }, { content: '아니요' }],
    additionalQuestion: [
      {
        idx: 1,
        name: 'socialRegister',
        type: 'radio',
        title: '소셜로그인(SNS 간편로그인)이 있나요?',
        subTitle: '',
        answer: [{ content: '네' }, { content: '아니요' }],
      },
    ],
  },
  // {
  //   idx: 5,
  //   name:'delivery',
  //   type: 'radio',
  //   title: '판매 상품이 배송이 되나요?',
  //   subTitle: '',
  //   answer: [{ content: '네' }, { content: '아니요' }],
  // },
  {
    idx: 6,
    name: 'notice',
    type: 'checkbox',
    title: `알림, 카카오채널, SMS안내가
필요하신가요?`,
    subTitle: '',
    answer: [
      { content: 'email' },
      { content: 'sms' },
      { content: '카카오알림톡' },
      { content: '플랫폼' },
      { content: '기타' },
      { content: '없음' },
    ],
  },
  {
    idx: 7,
    name: 'etcService',
    type: 'checkbox',
    title: `추가적으로 필요한
홈페이지 기능이 있으신가요?`,
    subTitle: '',
    answer: [
      { content: '게시판' },
      { content: '쿠폰' },
      { content: '후기' },
      { content: '채팅' },
      { content: '통계' },
      { content: '번역' },
      { content: '예약' },
      { content: '유튜브' },
      { content: '지도' },
    ],
  },
  {
    idx: 8,
    type: 'text',
    title: '설문에 응해주셔서 감사합니다',
    subTitle: '연락받으실 정보를 작성해주세요',
    answer: [
      { name: 'company', content: '회사명' },
      { name: 'name', content: '담당자명' },
      { name: 'phone', content: '연락처' },
      { name: 'email', content: '이메일' },
      { name: 'budget', content: '예산' },
      { name: 'reference', content: '레퍼런스' },
      { name: 'etcTechMessage', content: '기타 기술사항' },
    ],
  },
]

export const hugcareSolutionList = [
  {
    title: '상담센터 관리 서비스',
    subTitle: '센터 운영 관리',
    description: [
      {
        content: `상담센터 운영 시간을 관리하고, 화상 상담을 진행하고, 상담 예약 신청을 
관리할 수 있습니다`,
      },
      {
        content: `상담 내역을 관리하고, 일지 작성을 통해 연속성 있는 전문적 상담 서비스가 
가능합니다`,
      },
      { content: `상담사 계정과 관리자 계정을 생성하고 관리할 수 있습니다` },
    ],
    img: require('assets/images/hugcare-solution_image1.png'),
  },
  {
    title: '상담센터 관리 서비스',
    subTitle: '예약 관리',
    description: [
      {
        content: `상담센터 운영 시간을 관리하고, 화상 상담을 진행하고, 상담 예약 신청을 
관리할 수 있습니다`,
      },
      {
        content: `상담 내역을 관리하고, 일지 작성을 통해 연속성 있는 전문적 상담 서비스가 
가능합니다`,
      },
      { content: `상담사 계정과 관리자 계정을 생성하고 관리할 수 있습니다.` },
    ],
    img: require('assets/images/hugcare-solution_image2.png'),
  },
  {
    title: '상담센터 관리 서비스',
    subTitle: '상담내역 관리',
    description: [
      {
        content: `상담센터 운영 시간을 관리하고, 화상 상담을 진행하고, 상담 예약 신청을 
관리할 수 있습니다`,
      },
      {
        content: `상담 내역을 관리하고, 일지 작성을 통해 연속성 있는 전문적 상담 서비스가 
가능합니다`,
      },
      { content: `상담사 계정과 관리자 계정을 생성하고 관리할 수 있습니다` },
    ],
    img: require('assets/images/hugcare-solution_image3.png'),
  },
  {
    title: '학교용 관리 서비스',
    subTitle: '학교 어드민',
    description: [
      {
        content: `교원과 학생의 서비스 사용 현황을 모니터링하고, 담당센터를 지정할 수 있습니다`,
      },
      {
        content: `관리자 계정을 생성하고 관리할 수 있습니다`,
      },
      { content: `관할 기기 별 상세 사용 내역과 상태를 파악할 수 있습니다` },
    ],
    img: require('assets/images/hugcare-solution_image4.png'),
  },
]

export const hugcareTeacherList = [
  {
    title: '자가검진',
    subTitle: '검사 페이지 / 검사 결과',
    description: [
      {
        content: `직무스트레스, 우울증 등 나의 상태를 스스로 점검할 수 있어요`,
      },
      {
        content: `키오스크에서 새로운 검사를 할 수도 있고, 
스마트폰 어플에서 중간 저장된 검사를 이어할 수 있어요`,
      },
      {
        content: `검진결과를 저장하고, 담당 심리센터에 공유해서 화상상담 시에 
활용할 수 있어요`,
      },
    ],
    img: require('assets/images/hugcare-teacher_image1.png'),
  },
  {
    title: 'AI챗봇',
    subTitle: 'AI 챗봇 상담',
    description: [
      {
        content: `친구와 대화하듯이 나의 고민을 AI챗봇과 나눌 수 있어요`,
      },
      {
        content: `챗봇과는 24시간 언제든지 맞춤형 상담이 가능해요`,
      },
      {
        content: `공유하는 모든 정보는 안전하게 보호되며, 
전문가 수준의 조언을 받을 수 있어요`,
      },
    ],
    img: require('assets/images/hugcare-teacher_image2.png'),
  },
  {
    title: '화상상담',
    subTitle: '화상 상담/화상 상담 예약',
    description: [
      {
        content: `키오스크를 이용하여 간편하게 자가 검진을 받고,
전문 상담사와 실시간으로 화상상담할 수 있어요`,
      },
      {
        content: `상담내용은 안전하게 저장되어, 
여러 번 상담을 받을 때 연속적이고 
더 심화된 조언을 받을 수 있어요`,
      },
    ],
    img: require('assets/images/hugcare-teacher_image3.png'),
  },
  {
    title: '마이페이지',
    subTitle: '마이페이지 / 지난 검진 결과',
    description: [
      {
        content: `그동안 진행한 자가검진결과를 확인하고, 상담 내역도 알아볼 수 있어요`,
      },
      {
        content: `키오스크에서 새로운 검사를 할 수도 있고, 
스마트폰 어플에서 중간 저장된 검사를 이어할 수 있어요`,
      },
      {
        content: `오늘의 마음의 온도를 기록하고 
모바일 앱에서 내 마음 온도의 추이를 
관찰할 수 있어요`,
      },
    ],
    img: require('assets/images/hugcare-teacher_image4.png'),
  },
]
export const hugcareFriendsList = [
  {
    title: '자가검진',
    subTitle: '검사 페이지 / 검사 결과',
    description: [
      {
        content: `우울증, 게임중독, 자살 및 자해 등 나의 마음건강을 진단할 수 있어요`,
      },
      {
        content: `나의 진로 준비도를 점검하고 부족한 면을 채울 수 있어요`,
      },
      {
        content: `키오스크에서 새로운 검사를 할 수도 있고, 
스마트폰 어플에서 중간저장된 검사를 이어할 수 있어요`,
      },
      {
        content: `검진결과를 저장하고, 담당 심리센터에 공유해서 화상상담 시에 
활용할 수 있어요`,
      },
    ],
    img: require('assets/images/hugcare-friends_image1.png'),
  },
  {
    title: 'AI챗봇',
    subTitle: 'AI 챗봇 상담',
    description: [
      {
        content: `AI 챗봇을 활용한 개인 맞춤형 사회정서교육이 가능해요`,
      },
      {
        content: `친구와 대화하듯이 나의 고민을 AI챗봇과 나눌 수 있어요`,
      },
      {
        content: `챗봇과는 24시간 언제든지 맞춤형 상담이 가능해요`,
      },
      {
        content: `공유하는 모든 정보는 안전하게 보호되며, 
전문가 수준의 조언을 받을 수 있어요`,
      },
    ],
    img: require('assets/images/hugcare-friends_image2.png'),
  },
  {
    title: '화상상담',
    subTitle: '화상 상담/화상 상담 예약',
    description: [
      {
        content: `키오스크를 통해 간편하고 신속하게 자가 검진을 받고,
전문 상담사와 실시간으로 화상상담할 수 있어요`,
      },
      {
        content: `상담내용은 안전하게 저장되어, 
여러 번 상담을 받을 때에 연속적이고 
더 심화된 조언을 받을 수 있어요`,
      },
      {
        content: `키오스크에서 새로운 검사를 할 수도 있고, 
스마트폰 어플에서 중간저장된 검사를 이어할 수 있어요`,
      },
    ],
    img: require('assets/images/hugcare-friends_image3.png'),
  },
  {
    title: '진로 추천',
    subTitle: '테마별 / 지역별 채용 정보',
    description: [
      {
        content: `관심 지역, 직종에 대한 채용 공고를 조회하고 지원할 수 있어요`,
      },
      {
        content: `관심있는 공고를 저장, 지원하고 내역을 기록할 수 있어요`,
      },
    ],
    img: require('assets/images/hugcare-friends_image4.png'),
  },
]
